import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { InputLayout } from 'record-it-components/input/InputLayout/InputLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
export type WorkTimeEntryNoteWidgetProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  workTimeEntry: WorkTimeEntry;
};
export const WorkTimeEntryNoteWidget: FunctionComponent<WorkTimeEntryNoteWidgetProps> = React.memo(props => {
  const $ = _c(16);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let workTimeEntry;
  if ($[2] !== t0) {
    ({
      workTimeEntry,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = workTimeEntry;
  } else {
    remainingProps = $[3];
    workTimeEntry = $[4];
  }
  const {
    t
  } = useTranslation();
  let t1;
  if ($[5] !== t) {
    t1 = t("components.workTime.WorkTimeEntryNoteWidget.label");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t || $[8] !== workTimeEntry.note) {
    t2 = () => <div>{workTimeEntry.note || t("components.workTime.WorkTimeEntryNoteWidget.noNote")}</div>;
    $[7] = t;
    $[8] = workTimeEntry.note;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <InputLayout label={t1}>{t2}</InputLayout>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== remainingProps || $[14] !== t3) {
    t4 = <div {...remainingProps}>{t3}</div>;
    $[13] = remainingProps;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
});